import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class SubReasonService {

  constructor(private ws: PostmethodService) { }

  subReasonCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "subReasonMaster");
  }

  getSalesReason(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "salesLostReasonsMaster");
  }
}
